export default function (val) {
    switch (val){
        case 'paymentItems':
            return 'PaymentItems';
        case 'regulars':
            return 'Notify';
        case 'certificates':
            return 'GiftCertificates';
        case 'statements':
            return 'BankStatements';
        case 'osv':
            return 'BalanceSheet';
        default:
            return val.charAt(0).toUpperCase() + val.substr(1);
    }
}